import React from "react";

import { Carousel } from "@/components/Carousel";
import { Media } from "@/components/elements/Media";

import styles from "./styles.module.css";

export const ProductCarousel = ({
  altText,
  images,
  className,
}: {
  altText: string;
  images: string[];
  className: string;
}) => {
  // BUILD SLIDES
  const slides = images.map((image, index) => {
    return (
      <div key={index} className={styles.carouselProductImageContainer}>
        <Media
          className={styles.carouselProductImage}
          src={image}
          alt={altText}
          aspectRatio="landscape"
          objectFit="cover"
          priority
          sizes={"100vw"}
        />
      </div>
    );
  });

  const carouselConfig = {
    slides: {
      perView: 1,
    },
    mode: "snap",
  };
  return (
    <div className={className}>
      <Carousel
        slides={slides}
        buttonContainerClassName={styles.buttonsContainer}
        carouselConfig={carouselConfig}
      />
    </div>
  );
};
